import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { BusinessBookDemoPopup } from './BusinessBookDemoPopup';

export const BUSINESS_BOOK_DEMO_POPUP = Symbol('BUSINESS_BOOK_DEMO');

export const useBusinessBookDemoPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(BUSINESS_BOOK_DEMO_POPUP, BusinessBookDemoPopup);
  });

  return useCallback(
    ({ onSubmit, onCancel }) => {
      popups.openPopup(BUSINESS_BOOK_DEMO_POPUP, {
        onClose: () => {
          popups.closePopup(BUSINESS_BOOK_DEMO_POPUP);
          onCancel();
        },
        onSubmit: (email) => {
          popups.closePopup(BUSINESS_BOOK_DEMO_POPUP);
          onSubmit(email);
        },
      });
    },
    [popups]
  );
};
